
const AccommodationTypeIcon = (): JSX.Element => {
  return (
    <div>
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 5.49609L9.5 2.68359L2 5.49609"
          stroke="#424242"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.875 15.3164H15.125"
          stroke="#424242"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.40625 10.6758C6.1829 10.6758 6.8125 10.0462 6.8125 9.26953C6.8125 8.49288 6.1829 7.86328 5.40625 7.86328C4.6296 7.86328 4 8.49288 4 9.26953C4 10.0462 4.6296 10.6758 5.40625 10.6758Z"
          stroke="#424242"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.70156 8.54761V12.4664H5.40625"
          stroke="#424242"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9965 12.4665V11.8383C14.9965 11.5004 14.9299 11.1657 14.8006 10.8535C14.6713 10.5413 14.4817 10.2576 14.2427 10.0186C14.0038 9.77967 13.7201 9.59011 13.4079 9.46078C13.0956 9.33146 12.761 9.26489 12.423 9.26489H8.70117"
          stroke="#424242"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default AccommodationTypeIcon;
